<template>
	<div class="list">列表</div>
</template>

<script>
export default {
	
}
</script>

<style scoped lang="less">
.list{
	
}
</style>
